import React from 'react';
import QuizQuestionTimer from './QuizQuestionTimer';
import { AnimateSharedLayout, motion, useMotionValue, useSpring } from 'framer-motion';

export default function RatingQuestion({
  showing,
  message,
  question,
  endedEarly,
  reportAnswer,
  isLocked,
  setIsLocked,
}) {
  const {
    Answers,
    Description,
    Extra: { min, max },
  } = question;
  const {
    timetoken,
    message: {
      data: { time },
    },
  } = message;

  const [selectedAnswer, setSelectedAnswer] = React.useState(false);
  const [lineWidth, setLineWidth] = React.useState(0);

  let ratings = [];
  for (let i = parseInt(min); i <= parseInt(max); i++) {
    ratings.push(i);
  }

  const index = !selectedAnswer ? -1 : ratings.findIndex(rating => rating == selectedAnswer);

  const lineRef = React.useRef(null);
  // lets calculate the success line
  let width = useSpring(lineWidth, spring);

  // After render we need to set line width
  React.useEffect(() => {
    if (showing && selectedAnswer) {
      const newWidth = (1 / (ratings.length - 1)) * index * lineRef.current.clientWidth;
      setLineWidth(newWidth);
    }
  });

  if (showing && selectedAnswer) {
    width.set(lineWidth);
  }

  const onQuestionEnd = () => {
    onQuestionAlreadyEnded();
  };

  const onQuestionAlreadyEnded = () => {
    setIsLocked(true);
    // give it a second in case people's timers are off by a bit
    setTimeout(() => {
      CrowdHub_App.INSTANCE.mServices.GetQuizQuestion(
        question.Id,
        function (aQuestionResponse) {
          setSelectedAnswer(aQuestionResponse.Answers[0].response?.response);
        },
        function () {},
        0,
      );
    }, 1000);
  };

  React.useEffect(() => {
    if (CrowdHub_App.INSTANCE.CurrentUser.IsLoggedIn() != true) {
      return;
    }
    if (!selectedAnswer) {
      return;
    }

    CrowdHub_App.INSTANCE.mServices.SyncQuizAddResponse(
      question.Id,
      Answers[0]?.answer_id ? Answers[0].answer_id : {},
      selectedAnswer,
      () => {},
      error => {},
      true,
    );
  }, [selectedAnswer]);

  return (
    <motion.div
      className={`question_question question_container question_message`}
      id={`${App.INSTANCE.CurrentUser.Id}${message.timetoken}`}
      variants={questionVariants}
      initial={'hidden'}
      animate={'show'}
    >
      <div className={`question ${isLocked ? 'locked' : ''}`}>
        <div className={`description`} dangerouslySetInnerHTML={{ __html: Description }} />
        <div className={`answers ratings`}>
          <AnimateSharedLayout>
            {ratings.map((rating, i) => {
              return (
                <div
                  key={`rating_${timetoken}${i}`}
                  className={`rating`}
                  onClick={e => {
                    setSelectedAnswer(rating);
                  }}
                  style={{ width: `${100 / ratings.length}%` }}
                >
                  <div className={`rating_value`}>{rating}</div>
                  <motion.div className={i <= index ? 'highlight ratings_dot' : 'ratings_dot'} />
                  {parseInt(selectedAnswer) === rating && (
                    <motion.div
                      layoutId={`rating_${timetoken}`}
                      className={`rating_indicator`}
                      transition={spring}
                      initial={{ scale: 2 }}
                      animate={{ scale: 1 }}
                    />
                  )}
                </div>
              );
            })}
            <div
              ref={lineRef}
              className={`ratings_line`}
              style={{ width: `${100 - 100 / ratings.length}%`, left: `${100 / ratings.length / 2}%` }}
            />
            <motion.div className={`ratings_small_line`} style={{ width, left: `${100 / ratings.length / 2}%` }} />
          </AnimateSharedLayout>
        </div>
        <QuizQuestionTimer
          questionTime={timetoken}
          questionDuration={time}
          onQuestionEnd={onQuestionEnd}
          onQuestionAlreadyEnded={onQuestionAlreadyEnded}
          endedEarly={endedEarly}
        />
      </div>
    </motion.div>
  );
}

const spring = {
  type: 'spring',
  stiffness: 500,
  damping: 35,
};

const questionVariants = {
  hidden: { opacity: 0, x: 50 },
  show: { opacity: 1, x: 0 },
};
